<template>
  <div>
    <div class="columns is-multiline">
      <div
        class="card column is-4"
        v-for="vente in listeVentes"
        :key="vente.id"
      >
        <div class="card-content">
          <div class="media">
            <div class="media-content">
              <p class="title is-4">
                {{ vente.profile.firstName + " " + vente.profile.lastName }}
              </p>
              <p class="subtitle is-6">
                {{ vente.profile.mail + " - " + vente.profile.tel }}
              </p>
            </div>
          </div>

          <div class="content">
            <span class="title is-4">Point relais de livraison :</span>
            <br />

            <span>Adresse 1 :</span>
            {{ vente.pointRelais.adresse1 }}
            <br />
            <span>Adresse 2 :</span>
            {{
              vente.pointRelais.adresse2 ? vente.pointRelais.adresse2 : "aucune"
            }}
            <br />
            <span>Code postal:</span>
            {{ vente.pointRelais.cp }}
            <br />
            <span> Ville :</span>
            {{ vente.pointRelais.ville }}
            <br />
            <span> Poids du colis :</span>
            {{ vente.grammes }} grammes
            <br />

            <br />
            <time>{{ vente.details.create_time.split("T")[0] }}</time>
          </div>

          <footer class="card-footer">
            <a
              href="http://connect.mondialrelay.com "
              target="_blank"
              class="is-success button"
              >Préparer l'expédition</a
            >

            <div class="buttons">
              <b-button class="card-footer-item is-info" @click="getCSV(vente)"
                >Télécharger csv</b-button
              >
              <b-button
                class="card-footer-item is-info"
                @click="detailModal(vente.panier)"
                >voir les achats</b-button
              >

              <b-button
                class="card-footer-item is-danger"
                @click="deleteVente(vente)"
                >Supprimer</b-button
              >
            </div>
          </footer>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ListeVentes from "../classes/ListeVentes.js";
import DetailPanier from "@/components/DetailPanier.vue";
import Panier from "../classes/Panier.js";

export default {
  name: "ListeProduits",
  created() {
    this.updateListeVentes();
  },
  computed: {
    listeVentes() {
      const resultat = this.$store.state.listeVentes;
      return (resultat || { liste: [] }).liste;
    },
  },
  methods: {
    getCSV(vente) {
      const csv = `;${vente.panier.prixLivraison.toFixed(2)};${
        vente.profile.lastName
      } ${vente.profile.firstName};;${vente.pointRelais.adresse1};;${
        vente.pointRelais.ville
      };${vente.pointRelais.cp};FR;${vente.profile.tel};;${
        vente.profile.mail
      };A;;;R;${vente.pointRelais.id};FR;24R;;1;${
        vente.grammes
      };;;;EUR;;;EUR;InstructionLivraison;1;;;0;Livraison Vinaigre;;;;;;;;;`;
      let hiddenElement = document.createElement("a");
      hiddenElement.href = "data:text/csv;charset=utf-8," + encodeURI(csv);
      hiddenElement.target = "_blank";
      hiddenElement.download = "people.csv";
      hiddenElement.click();
    },
    detailModal(panierClient) {
      const panier = new Panier(panierClient);
      this.$buefy.modal.open({
        parent: this,
        props: { panier: panier, isFreeze: true },
        component: DetailPanier,
        width: 1600,
      });
    },
    updateListeVentes: async function () {
      const maListe = new ListeVentes();
      await maListe.getVentes();
    },
    deleteVente: async function (vente) {
      this.$buefy.dialog.confirm({
        title: "Supprimer la vente ?",
        message:
          "Il vaut mieux la garder jusqu'a ce que le client a été livré.",
        type: "is-danger",
        hasIcon: true,
        icon: "info-circle",
        ariaRole: "alertdialog",
        ariaModal: true,
        cancelText: "Annuler",
        confirmText: "Supprimer la vente",
        onConfirm: async () => {
          await vente.deleteVente();
          this.updateListeVentes();
        },
      });
    },
  },
};
</script>

<style lang="sass" scoped>
.is-sold-out
  background-color: red !important
</style>
